export default __webpack_public_path__ + "static/media/US.ca8c3f56.svg";